var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.name !== 'landing-page.watchvideo')?_c('FrontendNav',{attrs:{"homeURL":{ name: 'dashboard.home-1' }}},[_c('template',{slot:"responsiveRight"},[_c('ul',{staticClass:"d-flex align-items-center justify-content-end list-inline m-0"})])],2):_vm._e(),_c('MainCategoryListItems')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }